import React, { lazy, Suspense } from 'react';
import { Redirect } from 'react-router-dom';
import store from '../store';

// 登录
const LoginComponent = lazy(() => import('../container/Login'));

/**
 * 登录
 */
const Login = (props) => {
    return (
        <Suspense fallback={null}>
            <LoginComponent {...props} />
        </Suspense>
    );
};

// 主页
const HomeComponent = lazy(() => import('../container/Home'));

/**
 * 主页
 */
const Home = (props) => {
    return (
        <Suspense fallback={null}>
            <HomeComponent {...props} />
        </Suspense>
    );
};

// 测试
const TestComponent = lazy(() => import('../container/Test'));

/**
 * 测试
 */
const Test = (props) => {
    return (
        <Suspense fallback={null}>
            <TestComponent {...props} />
        </Suspense>
    );
};

// 桌面
const DesktopComponent = lazy(() => import('../container/Desktop'));

/**
 * 桌面
 */
const Desktop = (props) => {
    return (
        <Suspense fallback={null}>
            <DesktopComponent {...props} />
        </Suspense>
    );
};

// 候选人详情
const CandidateDetailComponent = lazy(() => import('../container/CandidateDetail'));

/**
 * 候选人详情
 */
const CandidateDetail = (props) => {
    return (
        <Suspense fallback={null}>
            <CandidateDetailComponent {...props} />
        </Suspense>
    );
};

// 候选人列表
const CandidateListComponent = lazy(() => import('../container/CandidateList'));

/**
 * 候选人列表
 */
const CandidateList = (props) => {
    return (
        <Suspense fallback={null}>
            <CandidateListComponent {...props} />
        </Suspense>
    );
};

// 职位详情
const CaseDetailComponent = lazy(() => import('../container/CaseDetail'));

/**
 * 职位详情
 */
const CaseDetail = (props) => {
    return (
        <Suspense fallback={null}>
            <CaseDetailComponent {...props} />
        </Suspense>
    );
};

// 职位列表
const CaseListComponent = lazy(() => import('../container/CaseList'));

/**
 * 职位列表
 */
const CaseList = (props) => {
    return (
        <Suspense fallback={null}>
            <CaseListComponent {...props} />
        </Suspense>
    );
};

// 报表
const ReportComponent = lazy(() => import('../container/Report'));

/**
 * 报表
 */
const Report = (props) => {
    return (
        <Suspense fallback={null}>
            <ReportComponent {...props} />
        </Suspense>
    );
};

// kpi报表
const ReportKpiComponent = lazy(() => import('../container/ReportKpi'));

/**
 * kpi报表
 */
const ReportKpi = (props) => {
    return (
        <Suspense fallback={null}>
            <ReportKpiComponent {...props} />
        </Suspense>
    );
};

// 成单报表
const ReportSuccessComponent = lazy(() => import('../container/ReportSuccess'));

/**
 * 成单报表
 */
const ReportSuccess = (props) => {
    return (
        <Suspense fallback={null}>
            <ReportSuccessComponent {...props} />
        </Suspense>
    );
};

// 设置
const SettingComponent = lazy(() => import('../container/Setting'));

/**
 * 设置
 */
const Setting = (props) => {
    return (
        <Suspense fallback={null}>
            <SettingComponent {...props} />
        </Suspense>
    );
};

// 账号管理
const AccountManageComponent = lazy(() => import('../container/AccountManage'));

/**
 * 账号管理
 */
const AccountManage = (props) => {
    return (
        <Suspense fallback={null}>
            <AccountManageComponent {...props} />
        </Suspense>
    );
};

// 密码管理
const PasswordManageComponent = lazy(() => import('../container/PasswordManage'));

/**
 * 密码管理
 */
const PasswordManage = (props) => {
    return (
        <Suspense fallback={null}>
            <PasswordManageComponent {...props} />
        </Suspense>
    );
};

// 个人信息
const PersonalInfoComponent = lazy(() => import('../container/PersonalInfo'));

/**
 * 个人信息
 */
const PersonalInfo = (props) => {
    return (
        <Suspense fallback={null}>
            <PersonalInfoComponent {...props} />
        </Suspense>
    );
};

// 消息
const MessageComponent = lazy(() => import('../container/Message'));

/**
 * 消息
 */
const Message = (props) => {
    return (
        <Suspense fallback={null}>
            <MessageComponent {...props} />
        </Suspense>
    );
};

// 职位消息
const MessageCaseComponent = lazy(() => import('../container/MessageCase'));

/**
 * 职位消息
 */
const MessageCase = (props) => {
    return (
        <Suspense fallback={null}>
            <MessageCaseComponent {...props} />
        </Suspense>
    );
};

// 推荐消息
const MessageRecommendComponent = lazy(() => import('../container/MessageRecommend'));

/**
 * 推荐消息
 */
const MessageRecommend = (props) => {
    return (
        <Suspense fallback={null}>
            <MessageRecommendComponent {...props} />
        </Suspense>
    );
};

// 系统消息
const MessageSystemComponent = lazy(() => import('../container/MessageSystem'));

/**
 * 系统消息
 */
const MessageSystem = (props) => {
    return (
        <Suspense fallback={null}>
            <MessageSystemComponent {...props} />
        </Suspense>
    );
};

export default [
    {
        path: '/',
        exact: true,
        render: () => {
            return <Redirect to="/login" />;
        }
    },
    {
        key: '登录',
        path: '/login',
        component: Login
    },
    {
        key: '候选人',
        path: '/candidate/:id',
        component: CandidateDetail,
        exact: true
    },
    {
        key: '主页',
        path: '/home',
        component: Home,
        routes: [
            {
                path: '/home',
                exact: true,
                render: () => {
                    return <Redirect to="/home/desktop" />;
                }
            },
            {
                // 桌面
                path: '/home/desktop',
                component: Desktop
            },
            {
                // 候选人详情
                path: '/home/candidate-detail/:id',
                component: CandidateDetail,
                exact: true
            },
            {
                // 候选人列表
                path: '/home/candidate',
                component: CandidateList
            },
            {
                // 职位详情
                path: '/home/case-detail/:id',
                component: CaseDetail,
                exact: true
            },
            {
                // 职位列表
                path: '/home/case',
                component: CaseList
            },
            {
                // 报表
                path: '/home/report',
                render: (props) => {
                    const state = store.getState();
                    if (state && state.user && state.user.isReport) {
                        return <Report {...props} />;
                    }
                    return <Redirect to="/home" />;
                },
                routes: [
                    {
                        path: '/home/report',
                        exact: true,
                        render: () => {
                            return <Redirect to="/home/report/kpi" />;
                        }
                    },
                    {
                        // kpi报表
                        path: '/home/report/kpi',
                        component: ReportKpi
                    },
                    {
                        // 成单报表
                        path: '/home/report/success',
                        component: ReportSuccess
                    }
                ]
            },
            {
                // 设置
                path: '/home/setting',
                component: Setting,
                routes: [
                    {
                        path: '/home/setting',
                        exact: true,
                        render: () => {
                            return <Redirect to="/home/setting/personal-info" />;
                        }
                    },
                    {
                        // 个人信息
                        path: '/home/setting/personal-info',
                        component: PersonalInfo
                    },
                    {
                        // 密码管理
                        path: '/home/setting/password-manage',
                        component: PasswordManage
                    },
                    {
                        // 账号管理
                        path: '/home/setting/account-manage',
                        component: AccountManage,
                        render: (props) => {
                            const state = store.getState();
                            if (state && state.user && state.user.isAdmin) {
                                return <AccountManage {...props} />;
                            }
                            return <Redirect to="/home/setting/personal-info" />;
                        }
                    }
                ]
            },
            {
                // 消息
                path: '/home/message',
                component: Message,
                routes: [
                    {
                        path: '/home/message',
                        exact: true,
                        render: () => {
                            return <Redirect to="/home/message/case" />;
                        }
                    },
                    {
                        // 职位消息
                        path: '/home/message/case',
                        component: MessageCase
                    },
                    {
                        // 推荐消息
                        path: '/home/message/recommend',
                        component: MessageRecommend
                    },
                    {
                        // 系统消息
                        path: '/home/message/system',
                        component: MessageSystem
                    }
                ]
            },
            {
                // 测试
                path: '/home/test',
                component: Test
            }
        ]
    }
];
